import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160-120v-480l320-240 320 240v480H560v-280H400v280H160Z" })
});
export default SvgHomeFill;
